<template>
  <div :key="language">
    <slot />
  </div>
</template>

<script setup lang="ts">
const language = useCurrentLanguage()
</script>
